'use client'
import { CardText } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

import { CardAnimationWrapper } from '../CardAnimationWrapper'
import { CardNetApyInnerWrapper, CardNetApyRoot } from '../CardNetApyParts'

export interface CardErrorProps {
  message: string
  className?: string
  isSmall?: boolean
  isExpanded?: boolean
}

const CardError = ({ message, className, isSmall, isExpanded }: CardErrorProps) => {
  return (
    <CardAnimationWrapper isSmall={isSmall} isExpanded={isExpanded}>
      <CardNetApyRoot className={className} style={{ height: '100%' }}>
        <CardNetApyInnerWrapper style={{ height: '100%' }}>
          <div className="gap-xs flex h-[100%] items-center justify-center">
            <CardText
              text={message}
              height="auto"
              width="100%"
              style={{ backgroundColor: 'transparent' }}
            />
          </div>
        </CardNetApyInnerWrapper>
      </CardNetApyRoot>
    </CardAnimationWrapper>
  )
}
export default memo(CardError)
